<template>
<Modal v-bind="$attrs" @input="$emit('input',$event)" title="数据导入" footer-hide :width="900">
  <BaseLoading v-if="loading" />
  <div
  v-else>
    <div class="flex-wrap flex-between" style="margin-bottom:10px;">
      <Input search v-model="searchText" size="small" style="width:200px;" clearable />

      <div class="flex-wrap">
        <Button @click="importExcel" size="small" style="margin-right:10px" v-if="items.length > 0">重新导入</Button>
        <Button @click="$emit('on-submit',items)" size="small" icon="md-checkmark" type="primary">提交数据</Button>

      </div>

    </div>
    <div style="height:400px;position:relative">
    <BaseTable
      :columns="importColumns"
      :data="filteredItems"
      :tableHeight="400"
      :page="1"
      :page-size="50"
      border
      :option="{
        key:this.columns.length > 0?this.columns[0].key:'id'
      }"
    />
</div>
  </div>

  <input
				ref="fileLoader"
				v-show="false"
				type="file"
				accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,*.csv"
				@change="parse"
			/>

</Modal>
</template>
<script>
import UTIL from '@/utils';
import moment from 'moment';
export default {
  data() {
    return {
      items: [],
      loading: true,
      searchText: '',
    };
  },
  props: {
    columns: {
      type: Array,
      default: ()=>([]),
    },
    header: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    filteredItems() {
      if (this.searchText) {
        return this.items.filter((v)=>{
          for (let i = 0; i<this.importColumns.length; i++) {
            const c = this.importColumns[i];
            if (typeof v[c.key] == 'string' && v[c.key].includes(this.searchText)) {
              return true;
            }
          }
          return false;
        });
      } else {
        return this.items;
      }
    },
    importColumns() {
      return [...this.columns.filter((v)=>v.key), {
        type: 'tool',
        width: '200',
        title: '操作',
        align: 'center',
        render: (h, {row, index})=>{
          const buttons = [
            h('Button', {props: {size: 'small'}, on: {
              click: ()=>{
                this.items.splice(index, 1);
              },
            }}, '删除'),
          ];
          return h('div', {class: 'flex-wrap flex-center'}, buttons);
        },
      }];
    },
  },
  methods: {
    importExcel() {
      this.$refs.fileLoader.click();
    },
    parse(file) {
      file = this.$refs.fileLoader.files[0];
      const that = this;
      this.loading = true;

      UTIL.file2Xce(file, {header: 1})
          .then((tabJson) => {
            if (tabJson && tabJson.length > 0) {
              const lines = tabJson[0].sheet;
              const items = [];

              lines.slice(this.header).forEach((line)=>{
                const item = {};
                if (Array.isArray(line) == false || line.length == 0) {
                  return;
                }
                this.columns.forEach((c, i)=>{
                  if (!c.key) {
                    return;
                  }
                  let val = line[i];
                  if (isNaN(val) && val !== '') {
                    val = val;
                  } if (!isNaN(val) && val > 20000 && val < 50000) {
                    val = moment('1900/01/01').add(val-2, 'days').format();
                  }
                  item[c.key] = val;
                });
                items.push(item);
              });

              this.items = items;
            } else {
              this.Error('excel表数据为空');
            }
          })
          .finally((e) => {
            that.$refs.fileLoader.value = '';
            this.loading = false;
          });
    },
  },
};
</script>
<style lang="less">
</style>
